import { useEventHook } from '@goodt-common/utils';

const enforcer = Symbol('ErrorService');
/**
 *
 */
export class ErrorService {
    static Scope = {
        GLOBAL: 'global'
    };

    /**
     *
     * @type {{on(callback: () => any): {off(): void}, off(callback: () => any): void, trigger(param: any): void}}
     * @private
     */
    _errorHook = useEventHook();

    /**
     *
     * @type {[]}
     * @private
     */
    _disposals = [];

    /**
     * Constructor
     *
     * @param {symbol} theEnforcer singleton enforcer
     */
    constructor(theEnforcer) {
        if (theEnforcer !== enforcer) {
            throw new Error(`Instantiation failed: use ErrorService.instance`);
        }
    }

    /**
     * @return {ErrorService}
     */
    static get instance() {
        if (this[enforcer] === undefined) {
            this[enforcer] = new ErrorService(enforcer);
        }
        return this[enforcer];
    }

    /**
     *
     * @param errorHandler
     * @return {*}
     */
    addHandler(errorHandler) {
        return errorHandler(this.handleError.bind(this));
    }

    /**
     * @private
     * @param {Error} error
     * @param {*} context
     * @param {string} scope
     * @param {string} message
     */
    handleError({ error, context, scope, message }) {
        this._errorHook.trigger({ error, context, scope, message });
    }

    /**
     * @param {import('./types').Subscriber<import('./types').ErrorInfoType>|function(): any} subscriber
     * @return {function(): void}
     */
    subscribe(subscriber) {
        const { off } = this._errorHook.on(subscriber);
        return off;
    }

    /**
     */
    dispose() {
        this._disposals.forEach((dispose) => dispose());
    }
}
